"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markPostsAsNotSpam = markPostsAsNotSpam;
exports.markPostsAsSpam = markPostsAsSpam;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = require("@insided/shared/utils/globals");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function markPostsAsSpam(_x, _x2) {
  return _markPostsAsSpam.apply(this, arguments);
}

function _markPostsAsSpam() {
  _markPostsAsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(posts, banUser) {
    var payload;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _objectSpread({
              action: 'markAsSpam',
              topics: posts
            }, banUser !== undefined && {
              params: {
                banUser: banUser
              }
            });
            _context.next = 3;
            return _axios.default.post('/community/api/bulk/process', payload);

          case 3:
            _context.next = 5;
            return _axios.default.post('/community/api/invalidateCache?apiPath=spamContent/count');

          case 5:
            (0, _globals.publish)('posts_marked_as_spam', {});

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _markPostsAsSpam.apply(this, arguments);
}

function markPostsAsNotSpam(_x3) {
  return _markPostsAsNotSpam.apply(this, arguments);
}

function _markPostsAsNotSpam() {
  _markPostsAsNotSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(posts) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/community/api/bulk/process', {
              action: 'markAsNotSpam',
              topics: posts
            });

          case 2:
            _context2.next = 4;
            return _axios.default.post('/community/api/invalidateCache?apiPath=spamContent/count');

          case 4:
            (0, _globals.publish)('posts_marked_as_not_spam', {});

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _markPostsAsNotSpam.apply(this, arguments);
}